export default __webpack_public_path__ + "static/media/eye-open.038523f8.svg";